<template>
    <div
        class="fixed top-5 right-0 mx-2 p-4 rounded-lg shadow-lg transition-opacity duration-300 max-w-md z-[99999]"
        :class="toastClass"
    >
        <div class="flex items-center">
            <CheckCircleIcon v-if="type === 'success'" class="mr-2 w-6 h-6" />
            <XCircleIcon v-if="type === 'error'" class="mr-2 w-6 h-6" />

            <span class="flex-1">{{ message }}</span>
            <button @click="$emit('close')" class="ml-4 text-lg font-bold">
                ×
            </button>
        </div>
    </div>
</template>

<script>
import { CheckCircleIcon, XCircleIcon } from "@heroicons/vue/24/solid";

export default {
    props: {
        type: {
            type: String,
            default: "info", // success, error, warning, etc.
        },
        message: {
            type: String,
            required: true,
        },
    },
    components: {
        CheckCircleIcon,
        XCircleIcon,
    },
    computed: {
        toastClass() {
            switch (this.type) {
                case "success":
                    return "bg-green-500 text-white";
                case "error":
                    return "bg-red-500 text-white";
                case "warning":
                    return "bg-yellow-500 text-white";
                default:
                    return "bg-blue-500 text-white";
            }
        },
    },
};
</script>
